import { GET_GENRE_PENDING, GET_GENRE_SUCCESS, GET_GENRE_FAILED } from "consts/actions"

import formatterHelper from "helpers/formatter"
import stateHelper from "helpers/state"

import consts from "consts"

export function getGenre(categoryId, genreId, page = 0) {
  const endpoint = consts.endpoints.genre

  const url = formatterHelper.basic(endpoint, { categoryId, kindId: genreId })

  return {
    accessTokenRequired: false,
    request: {
      url,
      method: "GET",
      params: {
        limit: 54,
        offset: page * 54,
      },
    },
    onStart: (payload, meta, dispatch) => {
      dispatch({
        type: GET_GENRE_PENDING,
      })
    },
    onSuccess: (payload, meta, dispatch) => {
      dispatch({
        type: GET_GENRE_SUCCESS,
        payload,
      })
    },
    onError: (payload, meta, dispatch) => {
      dispatch({
        type: GET_GENRE_FAILED,
        payload: stateHelper.errorPayload(payload.user_message, meta.httpCode),
      })
    },
  }
}
